<template>
  <div class="m-3 p-3 bg-light shadow rounded" >
    <b-row class="m-0 text-dark" v-b-toggle="'collapse-category-'+ category.category._id">
      <font-awesome-icon style="font-size: 20px;" :style="company.active ? '' : 'cursor: move'" icon="bars"/>
      <p class="m-0 ml-4">{{category.category.title}} ({{category.menuitems.length}})</p>
    </b-row>
    <b-collapse :id="'collapse-category-'+ category.category._id" class="">
      <draggable :options="{disabled: !dropable || company.active}" style="min-height: 20px" :list="category.menuitems" group="people" @start="$emit('disabled', true)" @end="$emit('disabled', false)" ghost-class="ghost-card" :move="onMove" :drag="onMove" @change="log" v-bind="dragOptions">
        <div :style="company.active ? '' : 'cursor: move'" v-for="menuitem in category.menuitems" :key="menuitem._id" class="p-3 mt-3 bg-white rounded shadow" >
          <b-row class="m-0">
            <b-col style="max-width: 40px">
              <b-row class="m-0 justify-content-center" v-if="!company.active">
                <b-button pill size="sm" variant="info" class="ml-2" @click="openMenuItemModal(menuitem)">
                  <b-icon v-if="!updating" icon="pencil" aria-hidden="true"></b-icon> <b-spinner v-if="updating" small label="Spinning"></b-spinner>
                </b-button>
              </b-row>
            </b-col>
            <b-col style="max-width: 10%">
              <span class="mr-3" v-if="menuitem.number">Nr. {{ menuitem.number }}</span>
            </b-col>
            <b-col style="width: 10%">
              <span class="mr-3">{{ menuitem.title }}</span>
            </b-col>
            <b-col style="width: 40%">
              <span class="mr-3">{{ menuitem.description }}</span>
            </b-col>
            <b-col style="width: 10%">
              <span class="mr-3">{{ getFixed(menuitem.price)}}€</span>
            </b-col>
            <b-col style="width: 10%">
              <b-form-checkbox
                class="text-center ml-2"
                @change="setMenuActive(menuitem)"
                switch size="md"
                v-model="menuitem.active"
              >
              {{menuitem.active ? 'aktiv' : 'inaktiv'}}
              </b-form-checkbox>
            </b-col>
            
            <!-- <b-col style="max-width: 40px">
              <b-row class="m-0 justify-content-center" v-if="!company.active">
                <b-button pill size="sm" variant="danger" class="ml-2" @click="deleteMenu(menuitem._id)">
                  <b-icon v-if="!updating" icon="trash" aria-hidden="true"></b-icon> <b-spinner v-if="updating" small label="Spinning"></b-spinner>
                </b-button>
              </b-row>
            </b-col> -->
            
          </b-row>
          
        </div>
      </draggable>
      <div class="mt-3" v-if="!company.active">
        <b-button size="sm" variant="success" @click="newMenuModal = true, newMenu.category = category.category"> Neue Speise in Kategorie {{ category.category.title }} anlegen </b-button>
      </div>
    </b-collapse>
    <!-- Edit MenuItem Modal -->
    <b-modal v-model="menuItemModal" size="xl" hide-footer hide-header v-if="menuItemBuffer">
      <div class="pt-2 rounded bg-white">
        <h2 class="text-center">{{ menuItemBuffer.title }}</h2>
        <b-tabs content-class="p-3 mt-1">

          <b-tab title="Speiseinfos" active>
            <div>
              <b-form @submit.prevent="updateMenuItem(menuItemBuffer)">

                  <b-form-group
                    class="mx-1"
                    label="Nummer:"
                    description="Nummer des Eintrages für eine leichtere Zuordnung der Bestellung und ist optional"
                  >
                    <b-form-input
                      v-model="menuItemBuffer.number"
                      type="text"
                      placeholder="Nummer eingeben"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    class="mx-1"
                    label="Name der Speise:"
                    description="Dieser Eintrag wird hervorgehoben dargestellt"
                  >
                    <b-form-input
                      v-model="menuItemBuffer.title"
                      type="text"
                      required
                      placeholder="Titel eingeben"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    class="mx-1"
                    label="Beschreibung:"
                    description="Dieser Eintrag wird ergänzend dargestellt"
                  >
                    <b-form-input
                      v-model="menuItemBuffer.description"
                      type="text"
                      placeholder="Beschreibung eingeben (optional)"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    class="mx-1"
                    label="Kategorie:"
                  >
                    <b-form-select required v-model="menuItemBuffer.category" :options="categoriesOptions"></b-form-select>
                  </b-form-group>
                  
                  <b-form-group
                    class="mx-1"
                    label="Preis in €:"
                  >
                    <b-form-input
                      v-model="menuItemBuffer.price"
                      type="number"
                      step="0.01"
                      required
                      placeholder="Preis eingeben"
                    ></b-form-input>
                  </b-form-group>
                
              </b-form>
            </div>
          </b-tab>

          <b-tab title="Varianten">
            <div class="mb-3 bg-light p-1 rounded" v-for="(variant, index) in menuItemBuffer.variants" :key="variant.index">
              <h5 class="ml-1">{{variant.title}}</h5>

              <div class="ml-2" v-for="vari in variant.variants" :key="vari.index">
                {{ variants.find(el => el._id == vari) ? variants.find(el => el._id == vari).title + ' (+ ' + variants.find(el => el._id == vari).price.toFixed(2) + '€)' : null }}
              </div>

              <b-button size="sm" variant="danger" class="mt-2 ml-1 mb-2" @click="menuItemBuffer.variants.splice(index, 1), updateMenuItem(menuItemBuffer)">
                <b-icon v-if="!updating" icon="trash" aria-hidden="true"></b-icon> <b-spinner v-if="updating" small label="Spinning"></b-spinner>
              </b-button>

              </div>
              <div class="mt-3">
                <b-form-group
                    v-if="variantsTemplates.length > 0"
                    class="mx-1"
                    label="Vorlage einfügen:"
                  >
                  <b-form-select @change="copyVariantsTemplate" v-model="copyVariants" :options="variantsTemplatesOptions.filter(extra => extra.value.category ? extra.value.category._id == menuItemBuffer.category._id : true)"></b-form-select>
                </b-form-group>
                <b-card>
                <h5 class="ml-1">Neue Variantenauswahl hinzufügen:</h5>
                
                <b-form @submit.prevent="addVariant(menuItemBuffer)">
                <b-form-group
                  class="mx-1"
                  label="Name der Variante:"
                  description="z.B.: Fleischsorte, Größe, Soße, Beilage "
                >
                  <b-form-input
                    style="width: 400px"
                    v-model="newMenuVariant.title"
                    type="text"
                    required
                    size="sm"
                    placeholder="Name eingeben"
                  ></b-form-input>
                </b-form-group>
                <b-form-checkbox-group
                  size="sm"
                  class="mx-1 mb-4"
                  v-model="newMenuVariant.variants"
                  :options="variantsOptions.filter(variant => variant.data.category ? variant.data.category._id == menuItemBuffer.category._id : true)"
                  name="variants"
                ></b-form-checkbox-group>
                
              <b-button class="mx-1" variant="primary" type="submit">hinzufügen</b-button>
            </b-form>
            </b-card>
          </div>
          </b-tab>

          <b-tab title="Extras">
            <b-form-group
              v-if="extrasTemplates.length > 0"
                class="mx-1"
                label="Vorlage verwenden:"
              >
              <b-form-select @change="copyExtrasTemplate" v-model="copyExtras" :options="extrasTemplatesOptions.filter(extra => extra.value.category ? extra.value.category._id == menuItemBuffer.category._id : true)"></b-form-select>
            </b-form-group>
            <b-card>
              <p class="m-0" v-if="menuItemBuffer.extraTemplate">Aktive Vorlage: {{ menuItemBuffer.extraTemplate.title }}</p>
              <b-form-checkbox-group
                class="my-3"
                :disabled="Boolean(menuItemBuffer.extraTemplate)"
                v-model="menuItemBuffer.extras"
                :options="extrasOptions.filter(extra => extra.data.category ? extra.data.category._id == menuItemBuffer.category._id : true)"
                name="allergens"
              ></b-form-checkbox-group>
              <div v-if="menuItemBuffer.extraTemplate">
                <b-button class="my-2" size="sm" @click="removeExtraTemplate(menuItemBuffer)"> Extras individualisieren </b-button>
                <div>
                  <small class="text-secondary">(individuelle Extras werden nicht mehr über die Vorlage aktualisiert)</small>
                </div>
              </div>
              
              
            </b-card>
            
          </b-tab>

          <b-tab title="Zusatzstoffe">
            <b-form-checkbox-group
              class="my-3"
              v-model="menuItemBuffer.additives"
              :options="additivesOptions"
              stacked
              name="additives"
            ></b-form-checkbox-group>
          </b-tab>

          <b-tab title="Allergene">
            <b-form-checkbox-group
              class="my-3"
              v-model="menuItemBuffer.allergens"
              :options="allergensOptions"
              stacked
              name="allergens"
            ></b-form-checkbox-group>
          </b-tab>

          <b-tab title="Produktbild">
            <b-card>
              
              <div class="image-preview text-left py-3" v-if="!imageData && menuItemBuffer.img">
                <img class="preview rounded shadow" alt="new" style="max-width: 50%" :src="getImage(menuItemBuffer.img.image)">
              </div>

              <div v-if="!imageData && !menuItemBuffer.img">
                <h5 class="text-center">Kein Bild ausgewählt</h5>
              </div>

              <div>
                <div class="image-preview text-left py-3" v-if="imageData.length > 0">
                  <img class="preview rounded shadow" alt="new" style="max-width: 50%" :src="imageData">
                </div>

                <b-row class="m-0">
                  <b-button @click="uploadsModal = true">Bild aus Mediathek wählen</b-button>
                  <b-button v-if="menuItemBuffer.img" class="ml-2" variant="danger" @click="menuItemBuffer.img = null">Bild entfernen</b-button>
                </b-row>

                

                <b-form-group
                  class="mt-3"
                  label="Neues Produktbild hochladen:"
                  description="Das Bild wird in den Produktinformationen angezeigt"
                >
                  <b-form-file
                    @change="previewImage" accept="image/*"
                    v-model="file"
                    :state="Boolean(file)"
                    placeholder="Wähle eine Datei aus..."
                    drop-placeholder="Hier her ziehen..."
                  ></b-form-file>
                </b-form-group>
                <div class="my-3">Ausgewählte Datei: {{ file ? file.name : '' }}</div>
                <b-button v-if="!uploadComplete" :disabled="!file" class="" variant="primary" @click="uploadImage">{{ file ? 'hochladen' : 'kein Bild ausgewählt'}}  <b-spinner v-if="updating" small label="Spinning"></b-spinner></b-button>
                <b-button v-else disabled class="" variant="primary"> Foto hochgeladen! <b-spinner v-if="updating" small label="Spinning"></b-spinner></b-button>
              </div>
              
            </b-card>
          </b-tab>

        </b-tabs>
        <b-row class="m-0 justify-content-between mb-4 pb-4 mx-4">
          <b-button class="" variant="primary" @click="updateMenuItem(menuItemBuffer)">aktualisieren<b-spinner v-if="updating" small label="Spinning"></b-spinner></b-button>
          <b-button @click="menuItemModal = false">schließen</b-button>
        </b-row>
      </div>
      
    </b-modal>

    <!-- New MenuItem Modal -->
    <b-modal v-model="newMenuModal" size="xl" hide-footer hide-header>
      <div class=" rounded bg-white">
        <b-row class="m-0 mx-4 pt-3 justify-content-between" style="border-top-left-radius: 10px; border-top-right-radius: 10px;">
          <h4>Speise hinzufügen</h4>
          <font-awesome-icon @click="newMenuModal = false" style="font-size: 30px; cursor: pointer" :icon="['fas', 'times']"/>
        </b-row>
          <div class="p-3" style="border-radius: 10px" >
          <b-form @submit.prevent="postMenu">
            <b-card>
              <b-form-group
                class="mx-1"
                label="Kopieren von bestehender Speise:"
              >
                <b-form-select @change="copyMenuItem()" v-model="copyMenu" :options="menuItemsOptions"></b-form-select>
              </b-form-group>

              <b-form-group
                class="mx-1"
                label="Name der Speise:"
                description="Dieser Eintrag wird hervorgehoben dargestellt"
              >
                <b-form-input
                  v-model="newMenu.title"
                  type="text"
                  required
                  placeholder="Titel eingeben"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                class="mx-1"
                label="Beschreibung:"
                description="Dieser Eintrag wird ergänzend dargestellt"
              >
                <b-form-input
                  v-model="newMenu.description"
                  type="text"
                  placeholder="Beschreibung eingeben (optional)"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                class="mx-1"
                label="Kategorie:"
              >
                <b-form-select required v-model="newMenu.category" :options="categoriesOptions"></b-form-select>
              </b-form-group>
                

              <b-form-group
                class="mx-1"
                label="Nummer:"
                description="Nummer des Eintrages für eine leichtere Zuordnung der Bestellung"
              >
                <b-form-input
                  v-model="newMenu.number"
                  type="text"
                  placeholder="Nummer eingeben"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                class="mx-1"
                label="Preis in €:"
              >
                <b-form-input
                  v-model="newMenu.price"
                  type="number"
                  step="0.01"
                  required
                  placeholder="Preis eingeben"
                ></b-form-input>
              </b-form-group>
              </b-card>
              <br>
              <b-card>
                <p>Beilagen</p>
                <div v-if="newMenu.category">
                <b-form-group
                  v-if="extrasTemplates.length > 0 && newMenu.category"
                    class="mx-1"
                    label="Vorlage verwenden:"
                  >
                  <b-form-select @change="copyExtrasTemplate" v-model="copyExtras" :options="extrasTemplatesOptions.filter(extra => extra.value.category ? extra.value.category._id == newMenu.category._id : true)"></b-form-select>
                </b-form-group>

                <b-card>
                  <p class="m-0" v-if="newMenu.extraTemplate">Aktive Vorlage: {{ newMenu.extraTemplate.title }}</p>
                  <b-form-checkbox-group
                    class="my-3"
                    :disabled="Boolean(newMenu.extraTemplate)"
                    v-model="newMenu.extras"
                    :options="extrasOptions.filter(extra => extra.data.category ? extra.data.category._id == newMenu.category._id : true)"
                    name="allergens"
                  ></b-form-checkbox-group>
                  <div v-if="newMenu.extraTemplate">
                    <b-button class="my-2" size="sm" @click="removeExtraTemplate(newMenu)"> Extras individualisieren </b-button>
                    <div>
                      <small class="text-secondary">(individuelle Extras werden nicht mehr über die Vorlage aktualisiert)</small>
                    </div>
                  </div>
                  
                </b-card>
                </div>
                <p v-else class="text-danger">Kategorie wählen!</p>

             
              </b-card>
              <br>
              <b-card>
                <p>Varianten</p>

                <div v-if="newMenu.category">
                  <div class="mb-3 bg-light p-1 rounded" v-for="(variant, index) in newMenu.variants" :key="variant.index">
                    <h5 class="ml-1">{{variant.title}}</h5>

                    <div class="ml-2" v-for="vari in variant.variants" :key="vari.index">
                      {{ variants.find(el => el._id == vari) ? variants.find(el => el._id == vari).title + ' (+ ' + variants.find(el => el._id == vari).price.toFixed(2) + '€)' : null }}
                    </div>

                    <b-button size="sm" variant="danger" class="mt-2 ml-1 mb-2" @click="newMenu.variants.splice(index, 1)" >
                      <b-icon v-if="!updating" icon="trash" aria-hidden="true"></b-icon> <b-spinner v-if="updating" small label="Spinning"></b-spinner>
                    </b-button>

                  </div>

                  <div class="mt-3" v-if="newMenu.category">
                      <b-form-group
                        v-if="extrasTemplates.length > 0 && newMenu.category"
                          class="mx-1"
                          label="Vorlage einfügen:"
                        >
                        <b-form-select @change="copyVariantsTemplate" v-model="copyVariants" :options="variantsTemplatesOptions.filter(extra => extra.value.category ? extra.value.category._id == newMenu.category._id : true)"></b-form-select>
                      </b-form-group>
                      <b-card>
                      <h5 class="ml-1">Neue Variantenauswahl hinzufügen:</h5>
                      
                      <b-form @submit.prevent="addVariant(newMenu)">
                      <b-form-group
                        class="mx-1"
                        label="Name der Variante:"
                        description="z.B.: Fleischsorte, Größe, Soße, Beilage "
                      >
                        <b-form-input
                          style="width: 400px"
                          v-model="newMenuVariant.title"
                          type="text"
                          required
                          size="sm"
                          placeholder="Name eingeben"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-checkbox-group
                        size="sm"
                        class="mx-1 mb-4"
                        v-model="newMenuVariant.variants"
                        :options="variantsOptions.filter(variant => variant.data.category ? variant.data.category._id == newMenu.category._id : true)"
                        name="variants"
                      ></b-form-checkbox-group>
                      
                    <b-button class="mx-1" variant="primary" type="submit">hinzufügen</b-button>
                  </b-form>
                  </b-card>
                  </div>
                </div>
                
                <p v-else class="text-danger">Kategorie wählen!</p>
             
              </b-card>
              <br>
              <b-card>
                <b-button size="sm" v-b-toggle.collapse-allergens-menu variant="primary">Allergene anzeigen</b-button>
                <b-collapse id="collapse-allergens-menu" class="mt-2">
                    <b-form-group
                      label="Allergene"
                    >
                      <b-form-checkbox-group
                        v-model="newMenu.allergens"
                        :options="allergensOptions"
                        name="allergens"
                        stacked
                      ></b-form-checkbox-group>
                  </b-form-group>
                </b-collapse>
              </b-card>
              <br>
              <b-card>
                <b-button size="sm" v-b-toggle.collapse-additives-menu variant="primary">Zusatzstoffe anzeigen</b-button>
                <b-collapse id="collapse-additives-menu" class="mt-2">
                  <b-form-group
                  label="Zusatzstoffe"
                  >
                    <b-form-checkbox-group
                      v-model="newMenu.additives"
                      :options="additivesOptions"
                      name="additives"
                      stacked
                    ></b-form-checkbox-group>
                  </b-form-group>
                </b-collapse>
              </b-card>
              <br>
            <b-row class="m-0 mx-1 justify-content-between">
              <b-button variant="success" type="submit">hinzufügen</b-button>
              <b-button @click="newMenuModal = false">schließen</b-button>
            </b-row>
            
          </b-form>
        </div>
      </div>
    </b-modal>
    
    <b-modal v-model="uploadsModal" hide-footer hide-header size="xl" v-if="media && userInformations">
      <div class=" rounded bg-white">
        <b-row class="m-0 mx-4 pt-3 justify-content-between" style="border-top-left-radius: 10px; border-top-right-radius: 10px;">
          <h4>Medienauswahl</h4>
          <font-awesome-icon @click="uploadsModal = false" style="font-size: 30px; cursor: pointer" :icon="['fas', 'times']"/>
        </b-row>
        <b-row class="m-0 justify-content-center">
          <img
            :key="img.index"
            v-for="img in media"
            class="m-2 hover preview rounded shadow"
            style="width: 40%; height: 40%"        
            :src="getImage('uploads/'+ userInformations._id +'/uploads/' + img)"
            alt="image slot"
            @click="setMediaImage('uploads/'+ userInformations._id +'/uploads/' + img)"
          >
        </b-row>
        <b-row class="m-0 justify-content-between mb-4 pb-4 mx-4">
          <b-button @click="uploadsModal = false">schließen</b-button>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import coreData from '@/mixins/coreDataMixin'
import draggable from 'vuedraggable'
import axiosAuth from '@/shared/configs/axios-auth'

export default {
  name: 'MenuCard',
  mixins: [coreData],
  props: {
    category: Object,
    dropable: Boolean
  },
  components: {
    draggable
  },
  data: () => {
    return {
      uploadsModal: false,
      menuItemBuffer: null,
      newMenuModal: false,
      menuItemModal: false,
      copyMenu: null,
      newMenu: {},
      copyExtras: null,
      copyVariants: null,
      newMenuVariant: {
        title: '',
        variants: []
      },
      imageData: "",
      file: null,
      uploadComplete: false,
    }
  },
  watch: {
    menuState(){
      if(this.menuState){
        this.makeToastMenu(false, 'success', this.newMenu.title)
        this.newMenu.title = ''
        this.newMenu.description = ''
      }else if(this.menuState === false){
        this.makeToastMenu(false, 'danger', 'FEHLER BEIM ANLEGEN!')
      }
    }
  },
  computed: {
    dragOptions() {
      // var vm = this
      return {
        group: {
          name: "menuitems",
        
          put() {
            return true
          }
        },
      };
    },
    menuItemsOptions(){
      var array = []
      if(this.categories && this.menus){

        this.categories.forEach(category => {

          var group = {
            label: category.title, 
            options: []
          }

          this.menus.filter(menu => menu.category._id == category._id && menu.category).forEach(element => {
            group.options.push({value: element, text: element.title, data: element})
          });

          array.push(group)

        })

        if(this.menus.filter(menu => !menu.category)){
          var group2 = {
            label: 'Ohne Kategorie', 
            options: []
          }

          this.menus.filter(menu => !menu.category).forEach(element => {
            group2.options.push({value: element, text: element.title, data: element})
          });

          array.push(group2)
        }
        
      }
      return array
    }
  },
  mounted(){
    
  },
  methods: {
    getFixed(value){
      try {
        value = parseFloat(value).toFixed(2)
      } catch (error) {
        console.log(error)
      }
      
      return value
    },
    onMove({ relatedContext, draggedContext }) {
      console.log(draggedContext)
      console.log(relatedContext)
    },
    log(value){
      console.log(value)
      for (let index = 0; index < this.category.menuitems.length; index++) {
        this.category.menuitems[index].sort_number = index;
        this.category.menuitems[index].category = this.category.category;
      }
      this.category.menuitems.forEach(menutitem => {
        this.updateMenuItem(menutitem)
      })
      console.log(this.category.menuitems)
    },
    setMenuActive(item){
      item.active = !item.active
      var payload = {
        _id: item._id,
        data: {
          active: item.active
        }
      }
      this.$store.dispatch('updateMenu', payload)
    },
    deleteMenu(id){
      this.$store.dispatch('deleteMenu', {_id: id})
    },
        copyMenuItem(){
      this.newMenu = JSON.parse(JSON.stringify(this.copyMenu))
      this.newMenu.title += ' (kopie)'
    },

    copyExtrasTemplate(value){
      console.log(value)
      if(this.menuItemBuffer){
        this.menuItemBuffer.extras = this.copyExtras.extras
        this.menuItemBuffer.extraTemplate = value
      }
      
      if(this.newMenuModal){
        this.newMenu.extras = this.copyExtras.extras
        this.newMenu.extraTemplate = value
      }

      this.copyExtras = null

    },

    copyVariantsTemplate(value){
      this.newMenuVariant.template = value._id
      this.newMenuVariant.variants = this.copyVariants.variants
      this.newMenuVariant.title = this.copyVariants.title
      if(this.newMenuModal){
        this.addVariant(this.newMenu)
      }else{
        this.addVariant(this.menuItemBuffer)
      }
      
    },

    makeToastMenu(append, variant, title) {
      console.log('TOAST!')
      this.toastCount++
      this.$bvToast.toast(title, {
        title: `Speise hinzugefügt!`,
        toaster: 'b-toaster-top-center',
        autoHideDelay: 3000,
        variant: variant,
        appendToast: append
      })
    },

    postMenu(){
      if(!this.newMenu.category || this.newMenu.category == undefined || !this.newMenu.title || !this.newMenu.price) return
      this.$store.dispatch('postMenu', this.newMenu)
      
      // this.newMenu = {
      //   extras: [],
      //   additives: [],
      //   allergens: []
      // }
      //this.newMenuModal = false
    },

    updateMenuItem(menuItem){
     
      var payload = {
        _id: menuItem._id,
        data: menuItem
      }

      this.$store.dispatch('updateMenu', payload)
    },

    openMenuItemModal(value){
      console.log(value)
      this.menuItemBuffer = value
      this.menuItemModal = true
    },

    setMediaImage(image){
      if(this.menuItemBuffer.img){
        this.menuItemBuffer.img.image = image
      }else{
        this.menuItemBuffer.img = {
          image: image,
          created: new Date(),
          type: "image/jpeg"
        }
      }
      
      console.log(image)
      this.uploadsModal = false
    },
    
    uploadImage(){
      this.$store.commit('updating', true)
      return new Promise((resolve, reject) => {

          if(!this.file){
            reject('Es wurde kein Logo hochgeladen!')
          }else{
            
            if(this.imageData){
              let formData = new FormData();

                formData.append('menu', this.menuItemBuffer._id)
                formData.append('image', this.file);

                axiosAuth.post('menus/upload/'+ this.menuItemBuffer._id, formData,)
                  .then(
                    () => {
                      resolve(true)
                      this.uploadComplete = true
                      this.$store.commit('updating', false)
                      this.$store.dispatch('getMedia')
                    }
                  )
                .catch(
                    error => {
                      this.$store.commit('updating', false)
                      console.log(error.response)
                      reject(error.response.data)
                    }
                ) 
            }else{
              this.$store.commit('updating', false)
              resolve(true)
            }
          }

      })
    },
    previewImage: function(event) {
        this.uploadComplete = false
        // Reference to the DOM input element
        var input = event.target;
        // Ensure that you have a file before attempting to read it
        if (input.files && input.files[0]) {
            // create a new FileReader to read this image and convert to base64 format
            var reader = new FileReader();
            // Define a callback function to run, when FileReader finishes its job
            reader.onload = (e) => {
                // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                // Read image as base64 and set to imageData
                this.imageData = e.target.result;
            }
            // Start the reader job - read file as a data url (base64 format)
            reader.readAsDataURL(input.files[0]);
        }
    },

        addVariant(menuitem){
      console.log(menuitem, this.newMenuVariant)
      if(menuitem.variants){
        menuitem.variants.push(JSON.parse(JSON.stringify(this.newMenuVariant)))
      }else{
        menuitem.variants = [JSON.parse(JSON.stringify(this.newMenuVariant))]
      }
      
      this.newMenuVariant = {
        template: null,
        title: '',
        variants: []
      }

      var payload = {
        _id: menuitem._id,
        data: menuitem
      }
      this.copyVariants = null
      if(this.newMenuModal) return
      this.$store.dispatch('updateMenu', payload)
      
    },
    removeExtraTemplate(item){
      item.extraTemplate = null
      console.log(item)
    },
  }
}
</script>

<style lang="scss" >
  .ghost-card {
    opacity: 0.5;
    background: #F7FAFC;
  }

  div:focus, input:focus{
    outline: none;
  }
</style>
